import React, { useEffect, useState } from 'react';
import { Navigation } from './Navigation';
import { Menu, X } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../UI/Button';
interface HeaderProps {
  openRegistrationForm?: () => void;
  openPaymentForm?: () => void;
}
export const Header = ({
  openRegistrationForm,
  openPaymentForm
}: HeaderProps) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const handleJoinNowClick = () => {
    // Navigate to the access points section on the home page
    if (window.location.pathname === '/') {
      // If already on home page, find and scroll to the access points section
      const accessPointsSection = document.querySelector('section.py-16.bg-gray-50');
      if (accessPointsSection) {
        accessPointsSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    } else {
      // If on another page, navigate to home and then to access points
      navigate('/?scrollToAccessPoints=true');
    }
  };
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Check URL params for scrollToAccessPoints
  useEffect(() => {
    if (window.location.search.includes('scrollToAccessPoints=true')) {
      setTimeout(() => {
        const accessPointsSection = document.querySelector('section.py-16.bg-gray-50');
        if (accessPointsSection) {
          accessPointsSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 500); // Small delay to ensure the page is fully loaded
    }
  }, []);
  return <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b border-gray-200 bg-white shadow-sm" data-id="element-726">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-727">
        <div className="flex items-center" data-id="element-728">
          <Link to="/" className="flex items-center" data-id="element-729">
            <div className="h-20" data-id="element-730">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rVLoSkFZL9a8o5YzEX4uvV/Logo_and_Teashirt_branding.png" alt="The Networking Salon Logo" className="h-full" data-id="element-731" />
            </div>
          </Link>
        </div>
        <div className="hidden md:flex items-center gap-4" data-id="element-732">
          <Navigation data-id="element-733" />
          <Button className="ml-4" onClick={handleJoinNowClick} data-id="element-734">
            Join Now
          </Button>
        </div>
        <div className="md:hidden" data-id="element-735">
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="p-2 border border-gray-300 rounded-md hover:border-primary text-secondary hover:text-primary" data-id="element-736">
            {mobileMenuOpen ? <X size={24} data-id="element-737" /> : <Menu size={24} data-id="element-738" />}
          </button>
        </div>
      </div>
      {/* Mobile menu */}
      {mobileMenuOpen && <div className="md:hidden bg-white border-t border-gray-200 shadow-md" data-id="element-739">
          <div className="container mx-auto px-4 py-4" data-id="element-740">
            <Navigation isMobile={true} data-id="element-741" />
            <div className="mt-4" data-id="element-742">
              <Button className="w-full" onClick={handleJoinNowClick} data-id="element-743">
                Join Now
              </Button>
            </div>
          </div>
        </div>}
    </header>;
};